<template>
	<div>
		<Header />
		<Carousel v-model="value" loop :height="400" arrow="never" dots="none">
			<CarouselItem>
				<div class="banner"
					:style="{'background': 'url('+require('@/assets/img/tableEntryService/caseBanner.jpg')+') center center no-repeat'}">
					<div>
						<p class="pageType">登记详情</p>
					</div>
				</div>
			</CarouselItem>
		</Carousel>
		<div class="mainContent">
			<Breadcrumb style="margin-bottom: 30px;">
				<BreadcrumbItem to="/">首页</BreadcrumbItem>
				<BreadcrumbItem :to="{path: '/caseLibrary',query:{ index:1, pageNum:this.$route.query.pageNum }}">
					登记列表
				</BreadcrumbItem>
				<BreadcrumbItem>详情</BreadcrumbItem>
			</Breadcrumb>

			<div class="registerContent">
				<div>
					<p class="registerTitle">基本信息</p>
					<ul>
						<li>
							<span>数据资产名称</span>
							<span>{{baseInfo.assetsName}}</span>
						</li>
						<li>
							<span>业务归属类型</span>
							<span>{{baseInfo.classification}}</span>
						</li>
						<li>
							<span>行业</span>
							<span>{{baseInfo.industry+'-'+baseInfo.territory}}</span>
						</li>
						<li>
							<span>应用场景</span>
							<span>{{baseInfo.scene}}</span>
						</li>
						<li style="width: 100%;">
							<span>资产描述</span>
							<span>{{baseInfo.assetsDescription}}</span>
						</li>
					</ul>
				</div>

				<div>
					<p class="registerTitle">数据要素信息</p>
					<ul>
						<li>
							<span>存储格式</span>
							<span>{{baseInfo.storageType}}</span>
						</li>
						<li>
							<span>存储类型</span>
							<span>{{baseInfo.storageClass}}</span>
						</li>
						<li>
							<span>数据来源</span>
							<span>{{baseInfo.dataSources}}</span>
						</li>
						<li>
							<span>是否敏感信息</span>
							<span>{{baseInfo.sourcesSensitive==1?'是':'否'}}</span>
						</li>
						<li>
							<span>数据规模数量</span>
							<span>
								{{baseInfo.dataElementScaleNum?baseInfo.dataElementScaleNum+baseInfo.dataElementScaleNumUnit:''}}
							</span>
						</li>
						<li>
							<span>数据规模大小</span>
							<span>
								{{baseInfo.dataElementScaleSize?baseInfo.dataElementScaleSize+baseInfo.dataElementScaleSizeUnit:''}}
							</span>
						</li>
						<li>
							<span>统计截止日期</span>
							<span>{{baseInfo.dataElementsEndTime}}</span>
						</li>
						<li>
							<span>数据要素更新频率</span>
							<span>{{baseInfo.frequency}}</span>
						</li>
						<li>
							<span>信息来源</span>
							<span>{{baseInfo.source}}</span>
						</li>
					</ul>
				</div>
				<div>
					<p class="registerTitle">数据资产质押信息</p>
					<ul>
						<li>
							<span>数据资产质押状态</span>
							<span>{{baseInfo.mortgageStatus}}</span>
						</li>
					</ul>
				</div>
				<div>
					<p class="registerTitle">申请主体</p>
					<ul>
						<li>
							<span>机构信息</span>
							<span>{{baseInfo.orgName}}</span>
						</li>
						<li>
							<span>统一社会信用代码</span>
							<span>{{baseInfo.orgId}}</span>
						</li>
					</ul>
				</div>



			</div>


		</div>


		<SignUp />
		<Footer />
	</div>
</template>

<script>
	import Header from '../../common/header/flow_header.vue'
	import Footer from '../../common/footer.vue'
	import publicMethod from '../publicMethod'
	import SignUp from '@/components/signUp/index.vue'

	import qs from 'qs'
	import axios from 'axios'

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			SignUp
		},
		data() {
			return {
				url: this.domain.testUrl + this.domain.valuationProject,
				value: 0,
				baseInfo: {

				}

			}
		},
		mounted() {
			this.getDataRegistrationDetail()


		},
		methods: {
			getDataRegistrationDetail(pageNum) {
				this.$post(this.url + 'dataRegistrationExchange/getDataRegistrationDetail', qs.stringify({
						productId: this.$route.query.id ? this.$route.query.id : ''
					}))
					.then(res => {
						this.baseInfo = res.data.content

					})

			}



		}


	}
</script>

<style scoped lang="less">
	.mainContent {
		margin-top: 30px;
	}

	.registerTitle {
		font-size: 24px;
		font-weight: bold;
		color: #282828;
		margin-bottom: 15px;
	}

	.registerContent {
		padding: 30px 40px;
		box-shadow: 2px 2px 13px 0px rgba(32, 76, 151, 0.23);

		ul {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			margin-bottom: 30px;

			li {
				width: 49%;
				margin-bottom: 15px;

				span {
					font-size: 18px;
					color: #282828;
					vertical-align: top;
					text-align: justify;
				}

				span:first-child {
					width: 180px;
					font-weight: bold;
				}

				span:last-child {
					width: calc(100% - 180px);
				}
			}
		}
	}
</style>